import {
    CATEGORY_LIST_PAGE_LOADED,
    CATEGORY_LIST_PAGE_UNLOADED,
    CATEGORY_ADD_PAGE_LOADED,
    CATEGORY_ADD_PAGE_UNLOADED,
    CATEGORY_DETAIL_PAGE_LOADED,
    CATEGORY_DETAIL_PAGE_UNLOADED,
    CATEGORY_UPDATE_PAGE_LOADED,
    CATEGORY_UPDATE_PAGE_UNLOADED,
    CATEGORY_ADD,
    CATEGORY_UPDATE,
    CATEGORY_DELETE,
    PRODUCT_LIST_PAGE_LOADED,
    PRODUCT_LIST_PAGE_UNLOADED,
    PRODUCT_ADD_PAGE_LOADED,
    PRODUCT_ADD_PAGE_UNLOADED,
    PRODUCT_DETAIL_PAGE_LOADED,
    PRODUCT_DETAIL_PAGE_UNLOADED,
    PRODUCT_UPDATE_PAGE_LOADED,
    PRODUCT_UPDATE_PAGE_UNLOADED,
    PRODUCT_ADD,
    PRODUCT_UPDATE,
    PRODUCT_DELETE
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case CATEGORY_LIST_PAGE_LOADED:
        case PRODUCT_ADD_PAGE_LOADED:
            return {
                ...state,
                categories: action.payload.categories,
            };
        case CATEGORY_DETAIL_PAGE_LOADED:
            return {
                ...state,
                category: action.payload[0].category,
                products: action.payload[1].products,
            };
        case CATEGORY_UPDATE_PAGE_LOADED:
            return {
                ...state,
                category: action.payload.category,
            }
        case CATEGORY_ADD:
        case CATEGORY_UPDATE:
        case CATEGORY_DELETE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true
            };

        case PRODUCT_LIST_PAGE_LOADED:
            return {
                ...state,
                products: action.payload.products,
            };
        case PRODUCT_DETAIL_PAGE_LOADED:
            return {
                ...state,
                product: action.payload.product,
            };
        case PRODUCT_UPDATE_PAGE_LOADED:
            return {
                ...state,
                product: action.payload[0].product,
                categories: action.payload[1].categories,
            }
        case PRODUCT_ADD:
        case PRODUCT_UPDATE:
        case PRODUCT_DELETE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true
            };
        case CATEGORY_LIST_PAGE_UNLOADED:
        case CATEGORY_ADD_PAGE_UNLOADED:
        case CATEGORY_DETAIL_PAGE_UNLOADED:
        case CATEGORY_UPDATE_PAGE_UNLOADED:
        case PRODUCT_LIST_PAGE_UNLOADED:
        case PRODUCT_ADD_PAGE_UNLOADED:
        case PRODUCT_DETAIL_PAGE_UNLOADED:
        case PRODUCT_UPDATE_PAGE_UNLOADED:
            return {};
        default:
            return state;
    }
};
